module.exports = __webpack_public_path__ + "media/images/our_apps/google_play_btn-08b42cf4a53d0be5c07bef80696d3b82.png";